export const isRouteMatch = (route: string, path: string) => {
  const routeParts = route.split('/');
  const pathParts = path.split('/');

  return routeParts.every((part, index) => part === pathParts[index]);
};
